import { api } from 'services/api';
import { Staff } from 'types';

export const staffApi = api
  .enhanceEndpoints({ addTagTypes: ['STAFF'] })
  .injectEndpoints({
    endpoints: (build) => ({
      getSTaff: build.query<Staff[], string>({
        query: (rootUserId) => ({
          url: `/users/admin/${rootUserId}/staff`,
          method: 'GET'
        }),
        providesTags: (_res, _meta, rootUserId) => [
          { type: 'STAFF', id: rootUserId }
        ]
      }),
      updateStaff: build.mutation<
        void,
        { rootUserId: string; staffUserId: string } & Omit<Staff, 'UserId'>
      >({
        query: ({ rootUserId, staffUserId, ...staff }) => ({
          url: `/users/admin/${rootUserId}/staff/${staffUserId}`,
          method: 'PUT',
          data: { ...staff, UserId: staffUserId }
        }),
        invalidatesTags: (_res, _err, { rootUserId }) => [
          { type: 'STAFF', id: rootUserId }
        ]
      }),
      deleteStaff: build.mutation<
        void,
        { rootUserId: string; staffUserId: string }
      >({
        query: ({ rootUserId, staffUserId }) => ({
          url: `/users/admin/${rootUserId}/staff/${staffUserId}`,
          method: 'DELETE'
        }),
        invalidatesTags: (_res, _err, { rootUserId }) => [
          { type: 'STAFF', id: rootUserId }
        ]
      })
    })
  });
